import create from "zustand";

interface CodeAndAreaProps {
  code: string;
  tamanhoAreaHa: number
}

interface OrdemService {
  code: string;
  date: string;
  team: string;
  operation: string;
  possuiPlanoOperacional: boolean;
  preCaldaCarregada: boolean;
  preCaldaProgramada: boolean;
}

interface ModalState {
  id?: string;
  ids?: string[];
  names?: string[];
  isOpen: boolean;
  ordemServicoIdAndColor: {ordemServicoId: string; talhaoIds?: string[]; color: string; codesAndArea: CodeAndAreaProps[]};
  allCheckeds: boolean;
  hiddenCompleteds: boolean;
  hidenBlockeds: boolean;
  operationName: string;
  checkedItems: Set<string>;
  openModalSuccessOS: boolean;
  listOperations: string[];
  ordemService: OrdemService;
  selectedItem: string | null;
  talhaoId: string;
  editChecked: boolean;
  activeEdit: boolean;
 
  setId: (args: string) => void;
  setIds: (args: string[]) => void;
  setNames: (args: string[]) => void;
  setIsOpen: (args: boolean) => void;
  setOrdemServicoIdAndColor: (args: any) => void;
  setAllCheckeds: (args: boolean) => void;
  setHiddenCompleteds: (args: boolean) => void;
  setHidenBlockeds: (args: boolean) => void;
  setOperationName: (args: string) => void;
  setCheckedItems: (updater: Set<string> | ((prev: Set<string>) => Set<string>)) => void;
  setOpenModalSuccessOS: (args: boolean) => void;
  setListOperations: (args: string[]) => void;
  setOrdemService: (args: OrdemService) => void;
  setSelectedItem: React.Dispatch<React.SetStateAction<string | null>>;
  setTalhaoId: (args: string) => void;
  setActiveEdit: (args: boolean) => void;
  setEditChecked: (args: boolean) => void;
}

const useModalOrdemServicoMatriz = create<ModalState>((set) => ({
  id: '',
  ids: [],
  names: [],
  isOpen: false,
  ordemServicoIdAndColor: {ordemServicoId: '', talhaoIds: [], color: '', codesAndArea: []},
  allCheckeds: false,
  hiddenCompleteds: false,
  hidenBlockeds: false,
  operationName: '',
  checkedItems: new Set(),
  openModalSuccessOS: false,
  listOperations: [],
  ordemService: {
    code: '',
    date: '',
    team: '',
    operation: '',
    preCaldaCarregada: false,
    preCaldaProgramada: false,
    possuiPlanoOperacional: false,
  },
  selectedItem: null,
  talhaoId: '',
  activeEdit: false,
  editChecked: false,

  setId: (id) => {
    set(state => ({ id }));
  },
  setIds: (ids) => {
    set(state => ({ ids }));
  },
  setNames: (names) => {
    set(state => ({ names }));
  },
  setIsOpen: (isOpen) => {
    set(state => ({ isOpen }));
  },

  setOrdemServicoIdAndColor: (ordemServicoIdAndColor) => {
    set(state => ({ ordemServicoIdAndColor }));
  },

  setAllCheckeds: (allCheckeds) => {
    set(state => ({ allCheckeds }));
  },

  setHiddenCompleteds: (hiddenCompleteds) => {
    set(state => ({ hiddenCompleteds }));
  },

  setHidenBlockeds: (hidenBlockeds) => {
    set(state => ({ hidenBlockeds }));
  },

  setOperationName: (operationName) => {
    set(state => ({ operationName }));
  },

  setCheckedItems: (updater) => {
    set((state) => {
      const newCheckedItems = typeof updater === 'function' 
        ? updater(state.checkedItems) 
        : updater;
      return { checkedItems: newCheckedItems };
    });
  },

  setOpenModalSuccessOS: (openModalSuccessOS) => {
    set(state => ({ openModalSuccessOS }));
  },

  setListOperations: (listOperations) => {
    set(state => ({ listOperations }));
  },

  setOrdemService: (ordemService) => {
    set(state => ({ ordemService }));
  },

  setSelectedItem: (value) => {
  set((state) => ({
    selectedItem:
      typeof value === "function"
        ? value(state.selectedItem)
        : value,
  }));
},

setTalhaoId: (talhaoId) => {
    set(state => ({ talhaoId }));
  },

  setActiveEdit: (activeEdit) => {
    set(state => ({ activeEdit }));
  },

  setEditChecked: (editChecked) => {
    set(state => ({ editChecked }));
  },
  
}));

export default useModalOrdemServicoMatriz;
